














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PenyebabNyeriHilang extends Vue {
  @Prop() setPenyebabNyeriHilang: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  // nyeriHilang = null;

  // @Watch("nyeriHilang")
  // changePenyebabNyeriHilang(val) {
  //   this.$emit("penyebabNyeriHilang", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (
        this.setPenyebabNyeriHilang == "" ||
        this.setPenyebabNyeriHilang == null
      ) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }

  @Watch("setPenyebabNyeriHilang")
  valPenyebabNyeriHilang(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("penyebabNyeriHilang", val);
    this.setPenyebabNyeriHilang = val;
  }
}
